import { generateIdempotencyKey } from './auth.js';
const PREFIX = 'keji.op:';
/** 键序无关的稳定序列化 —— 与服务端幂等中间件「入参键序不同不算异参」同一口径 */
export function stableStringify(value) {
    if (Array.isArray(value))
        return `[${value.map(stableStringify).join(',')}]`;
    if (typeof value === 'object' && value !== null) {
        const entries = Object.entries(value)
            .filter(([, v]) => v !== undefined)
            .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
        return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${stableStringify(v)}`).join(',')}}`;
    }
    return JSON.stringify(value) ?? 'null';
}
function read(storage, scope) {
    try {
        const raw = storage.getItem(PREFIX + scope);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        if (typeof parsed.key !== 'string' || typeof parsed.pinnedAt !== 'string')
            return null;
        return {
            key: parsed.key,
            payload: parsed.payload,
            pinnedAt: parsed.pinnedAt,
            reused: true,
        };
    }
    catch {
        // 存储读不到(隐私模式、被清)不影响业务:退化为一次性的键
        return null;
    }
}
/** 读出当前钉住的操作(有的话)。给界面提示「上次算价还没得到回应」用 */
export function readPinnedOperation(storage, scope) {
    return read(storage, scope);
}
/**
 * 钉住一次操作:同作用域、同参数 → 沿用键;否则新键并覆盖存储。
 * 存储写失败时仍返回可用的键 —— 不因本地存储问题拦住业务,只是失去跨次点击的保护。
 */
export function pinOperation(storage, scope, payload, options = {}) {
    const existing = read(storage, scope);
    if (existing && stableStringify(existing.payload) === stableStringify(payload))
        return existing;
    const fresh = {
        key: (options.generateKey ?? generateIdempotencyKey)(),
        payload,
        pinnedAt: (options.now ?? (() => new Date()))().toISOString(),
        reused: false,
    };
    try {
        storage.setItem(PREFIX + scope, JSON.stringify({ key: fresh.key, payload: fresh.payload, pinnedAt: fresh.pinnedAt }));
    }
    catch {
        /* 见上:退化为一次性的键 */
    }
    return fresh;
}
/** 操作明确结束:成功拿到结果,或被服务端明确拒绝(不是网络不确定) */
export function releaseOperation(storage, scope) {
    try {
        storage.removeItem(PREFIX + scope);
    }
    catch {
        /* 同上 */
    }
}
/** 纯内存实现:测试与不支持本地存储的环境用 */
export function memoryStorage() {
    const map = new Map();
    return {
        getItem: (k) => map.get(k) ?? null,
        setItem: (k, v) => void map.set(k, v),
        removeItem: (k) => void map.delete(k),
    };
}
//# sourceMappingURL=operation.js.map